import Image from 'next/image';
import styles from './InteriorServices.module.css';
export function InteriorServices() {
    return (
        <section className="section bgLigtgray">
            <div className="containerFull">
                <h2 className="font26 textCenter f500 text000 mb20 fontSM20 mbSM15">Ready To Use Interior Design<span className="textpink"> Services</span></h2>
                <span className={`font16 textCenter  displayBlock ${styles.comPletmainbox}`}>Our team of experts works closely on every detail so that you get the best interior design services in Dubai.</span>
                <div className={styles.desginTueskminb}>
                    <div className={styles.designTurtiles}>
                        <Image className="img-responsive mb20 mbSM15" width={57} height={60} src="/assets/images/Architecture-des.svg" alt="Architecture" />
                        <h3>Seamless Execution</h3>
                        <p>A subtle architectural design is the heart of any home. Our architectural design services give meaning to your space while enhancing its overall aesthetic appeal.</p>
                    </div>
                    <div className={styles.designTurtiles}>
                        <Image className="img-responsive mb20 mbSM15" width={57} height={60} src="/assets/images/innovativeDesign.svg" alt="innovativeDesign" />
                        <h3>Innovative Designs</h3>
                        <p>Regarding interior design services, we offer superior interior designs backed by an innovative approach that fits your budget.</p>
                    </div>
                    <div className={styles.designTurtiles}>
                        <Image className="img-responsive mb20 mbSM15" width={57} height={60} src="/assets/images/Bespoke.svg" alt="Bespoke" />
                        <h3>Bespoke Luxury Homes</h3>
                        <p>Every nook and cranny has a tale to tell. Hence,  we assist you with bespoke luxury homes while providing the ideal balance of elegance & excellence.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}